import React from 'react';

interface IProps {
  html: string;
}

const GridCellHtml: React.FC<IProps> = ({ html }) => {
  return (
    <td colSpan={1} role="gridcell" aria-selected="false">
      {html?.startsWith('<') && html?.endsWith('>') ? (
        <div
          className="ignore-styles"
          dangerouslySetInnerHTML={{ __html: html }}
          style={{ backgroundColor: 'transparent' }}
        />
      ) : (
        <div>{html}</div>
      )}
    </td>
  );
};

export default GridCellHtml;
